import React, { useState } from "react";
import { Button, Table, Modal } from "react-bootstrap";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import BSPagination from "../../Components/pagination";
import LoadingSpinner from "../../Components/spinner";
import { handleErrors } from "../../services/dataManager";
import { RiShareBoxFill } from "react-icons/ri";
import { isAfter, isBefore } from "date-fns";

const HomePageList = ({ sections, pagination }) => {

  const getEventStatus = (content, now = new Date()) =>
    isBefore(new Date(content?.end_date), now)
      ? "expired"
      : isAfter(new Date(content?.start_date), now)
        ? "in_future"
        : "in_progress";

  return (
    <div className="bg-dark p-4 rounded mb-4">
      <div className="table-responsive mt-4">
        {/* <div className="bg-dark p-4 rounded mb-4"> */}
        <Table striped bordered hover variant="dark" className="mt-4">
          <thead>
            <tr>
              <th>Heading</th>
              <th>Games</th>
              <th>Period</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {sections?.length > 0 &&
              sections.map((content, index) => (
                <tr key={index}>
                  <td>{content.heading}</td>
                  {/* <td>{content.content}</td> */}
                  {/* <td>{content?.games?.length}</td> */}
                  {content?.games_included ? (
                    <td>
                      <button
                        className="btn btn-link d-flex align-items-center text-primary"
                        style={{ textDecoration: "none" }}
                        onClick={() => {
                          // navigate(`/AdsApi/Ad-Unit/${adApi?.id}`);
                        }}
                      >
                        {`${content?.games?.length} games`}
                        <RiShareBoxFill className="mx-1" />
                      </button>
                    </td>
                  ) : (
                    <td>Not Included</td>
                  )}
                  {content.is_timed ? (
                    <td>{getEventStatus(content)}</td>
                  ) : (
                    <td>permanent</td>
                  )}
                  <td>
                    <button
                      className={`btn btn-link p-0 m-0 border-0 ${
                        content.status ? "text-success" : "text-danger"
                      }`}
                      onClick={() => {
                        //   handleStatusChange(content);
                      }}
                      style={{ textDecoration: "none" }}
                    >
                      {content.status === 1 ? "Active" : "Inactive"}
                    </button>
                  </td>
                  <td className="w-32">
                    <Button
                      variant="outline-primary"
                      className="ml-1 mr-1"
                      size="sm"
                      onClick={() => {
                        //   handleOpenEditModal(content);
                      }}
                    >
                      <FaEdit />
                    </Button>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={() => {
                        //   handleDeleteContent(content);
                      }}
                    >
                      <FaTrashAlt />
                    </Button>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        <div className="constainer-fluid">
          <div className="d-flex justify-content-end">
            {/* <div className="mx-4 py-2">
              <span className="text-light">{`Rows/Page ${pagination?.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
            </div> */}
            <BSPagination
              currentPage={pagination?.currentPage}
              totalPages={pagination?.totalPages}
              onPageChange={() => {}}
              // onPageChange={handlePageChange}
              siblingCount={2}
              showFirstLast={true}
            />
          </div>
        </div>
        {/* </div> */}
      </div>
      {/* <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal> */}
    </div>
  );
};

export default HomePageList;
